import { OVERRIDE_LINKS } from './constants';

const getSofaBuilderLink = (collectionName, link, marxentPostHogFlag) => {
  if (marxentPostHogFlag === "test" || !collectionName) {
    return link;
  }
  return OVERRIDE_LINKS[collectionName] || link;
};

export default getSofaBuilderLink;